<template>
    <button @click="share" v-bind="$attrs">
        <svg class="icon" aria-label="카카오톡 공유" :width="size" :height="size" :viewBox="`0 0 48 48`" preserveAspectRatio="xMidYMid meet">
            <g fill="none" fill-rule="evenodd">
                <path fill="#FFEB00" d="M0 24a24 24 0 1 1 48 0 24 24 0 0 1-48 0z"></path>
                <path
                    fill="#3C2929"
                    d="M24 11.28c8.28 0 15 5.3 15 11.85 0 6.54-6.72 11.85-15 11.85-.92 0-1.82-.07-2.7-.2l-6.08 4.11a.43.43 0 0 1-.67-.48l1.41-5.28c-4.18-2.1-6.96-5.8-6.96-10 0-6.55 6.72-11.85 15-11.85zm10.86 15.17c.03-.3-.14-.52-.35-.8l-2.04-2.67 1.72-1.74.18-.2c.23-.26.35-.39.35-.59.01-.42-.34-.65-.68-.66a.8.8 0 0 0-.57.27l-2.53 2.63v-2.3c0-.42-.3-.7-.72-.7s-.72.3-.72.7v5.94c0 .41.3.69.72.69.41 0 .72-.3.72-.69V24.4l.51-.53 1.89 2.57c.28.38.42.54.69.57h.11c.16 0 .66-.04.72-.56zm-5.98-.14a.64.64 0 0 0-.17-.48.69.69 0 0 0-.51-.2h-2v-5.2c0-.46-.27-.75-.71-.75-.44 0-.72.3-.72.75v5.71c0 .5.28.8.75.8h2.68c.43 0 .67-.33.68-.63zm-5.51.7c.37 0 .65-.27.65-.61 0-.06-.01-.2-.08-.37l-2.02-5.51c-.18-.53-.57-.84-1.06-.84-.56 0-.92.44-1.07.84l-2.08 5.52a.84.84 0 0 0-.07.31c0 .37.31.67.7.67.37 0 .58-.17.7-.51l.32-.97h3l.31.98c.11.33.34.5.7.5zm-6.94-.75v-5.2h1.5c.48 0 .65-.36.65-.66 0-.32-.23-.65-.64-.65h-4.46c-.41 0-.64.33-.64.65 0 .3.17.65.64.65H15v5.21c0 .47.28.76.72.76.44 0 .72-.3.72-.76zM20.84 21a.01.01 0 0 1 .03 0l1.08 3.26h-2.19L20.84 21z"
                ></path>
            </g>
        </svg>
        <span>카카오톡</span>
    </button>
</template>

<script>
export default {
    props: {
        size: { type: String, default: "60" },
        kakaoData: Object,
    },
    methods: {
        share() {
            Kakao.Link.sendDefault({
                ...this.kakaoData,
            });
        },
    },
};
</script>
